import { render, staticRenderFns } from "./PredelovalecKratko.vue?vue&type=template&id=4e066cde&"
import script from "./PredelovalecKratko.vue?vue&type=script&lang=js&"
export * from "./PredelovalecKratko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports